export const RETAIL_USER = "RetailUser";
export const STORESXUSER = "StoresXUser";
export const ISMENUCOLLAPSED = "isMenuCollapsed";
export const USER_TIMEOUT = "UserTimeout";